import styled from 'styled-components';

const Container = styled.div`
  background: #ffffff;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const HeaderContent = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 19px 24px 19px 24px;

  @media (min-width: 1280px) {
    width: 1280px;
  }
  @media (min-width: 992px) {
    padding: 20px 32px 20px 32px;
  }
`;

const IntroUtp = styled.div`
  display: flex;
  gap: 16px;
`;

const IntroName = styled.div`
  display: none;
  @media (min-width: 468px) {
    display: flex;
    flex-direction: column;
  }
`;

const IntroText = styled.div`
  display: flex;
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
  color: #161d1f;
`;

const NameUser = styled.p`
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  padding-left: 4px;
`;

const IntroText1 = styled.div`
  display: flex;
  justify-content: flex-end;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #4f6168;
`;

const IntroIcon = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  .mr_icon {
    margin-right: 8px;
  }

  .invisible {
    visibility: hidden;
  }

  .visible {
    visibility: visible;
  }
`;

const ArrowDown = styled.button`
  color: #e1edf4;
  display: flex;

  &:hover {
    background: #e2dffd;
    border-radius: 4px;
    cursor: pointer;
  }

  &:focus {
    background: #c6c0fc;
    border-radius: 4px;
  }

  &:active {
    color: #c6c0fc;
  }
`;

const Logout = styled.ul`
  display: flex;
  width: 95%;
  overflow-y: auto;
  position: absolute;
  z-index: 100;
  top: 105px;
  left: 50%;
  transform: translate(-50%, -50%);
  justify-content: flex-end;

  @media (min-width: 1280px) {
    width: 1240px;
  }
`;

const LogoutButton = styled.button`
  background: #ffffff;
  display: flex;
  align-items: center;
  padding: 10px 16px 10px 18px;
  width: 141px;
  box-shadow: 0px 1.2px 4px #eaeef1;
  border-radius: 4px;
`;

export {
  Container,
  HeaderContent,
  IntroUtp,
  IntroIcon,
  ArrowDown,
  IntroText,
  IntroText1,
  IntroName,
  NameUser,
  Logout,
  LogoutButton
};
